var isCSSVar = function isCSSVar(name) {
  return name.startsWith("--");
};

export { isCSSVar };